import CloseIcon from "@mui/icons-material/Close"
import WarningRoundedIcon from "@mui/icons-material/WarningRounded"
import { useTheme } from "@mui/material"
import Alert, { AlertColor } from "@mui/material/Alert"
import Box from "@mui/material/Box"
import Collapse from "@mui/material/Collapse"
import IconButton from "@mui/material/IconButton"
import { useState } from "react"
interface Props {
    alertMessage: string
    severity: AlertColor
    alertMessageBold?: string
}
export default function TransitionAlerts({ alertMessage, severity, alertMessageBold }: Props) {
    const theme = useTheme()
    const [open, setOpen] = useState(true)

    return (
        <Box sx={{ width: "100%" }}>
            <Collapse in={open}>
                <Alert
                    icon={<WarningRoundedIcon />}
                    severity={severity}
                    variant="filled"
                    sx={{ color: theme.palette.common.white }}
                    action={
                        <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => {
                                setOpen(false)
                            }}
                        >
                            <CloseIcon fontSize="inherit" />
                        </IconButton>
                    }
                >
                    <b>{alertMessageBold}</b> {alertMessage}
                </Alert>
            </Collapse>
        </Box>
    )
}
